import React, { useContext, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";
import ReportTemplate from "./ReportTemplate";
import SecureLS from "secure-ls";
import useSWR from "swr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import AddCTScanReportRegister from "./AddCTScanReportRegister";
import EditCTScanReportRegister from "./EditCTScanReportRegister";
import { AppContext } from "./AppContext";
import moment from "moment";

const ls = new SecureLS({ encodingType: "aes" });

const fetcher = async (url) => {
  const token = ls.get("usercsrf_token") || "";
  const absoluteUrl = url.startsWith("http")
    ? url
    : `${process.env.REACT_APP_BASE_URL}${url}`;

  const res = await fetch(absoluteUrl, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    },
  });

  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);
  return res.json();
};

const ViewCTScanReportRegister = ({ permuser }) => {
  const { selectedData } = useContext(AppContext);
  const [modalAddReport, setModalAddReport] = useState(false);
  const [modalEditReport, setModalEditReport] = useState(false);

  const toggleModalAddReport = () => setModalAddReport(!modalAddReport);
  const toggleModalEditReport = () => setModalEditReport(!modalEditReport);

  const report_nid = selectedData?.report_nid;
  // const request_field_investigation_price =
  //   selectedData?.request_field_investigation_price;
  // console.log("REQUEST INVESTIGATION PRICE", request_field_investigation_price);

  // Only fetch report if it exists
  const {
    data: reportData,
    isLoading,
    // error,
  } = useSWR(
    report_nid
      ? `${process.env.REACT_APP_BASE_URL}/jsonapi/node/ct_scan_report/${selectedData?.report_uuid}?include=uid`
      : null,
    fetcher,
    {
      refreshInterval: 2000,
      revalidateOnFocus: true,
    }
  );
  console.log("REPORT DATA JSON API", reportData);
  console.log("REPORT DATA JSON ID API", reportData?.data.id);

  const reportedDate = reportData?.data?.attributes?.created
    ? moment(reportData.data.attributes.created).format("DD-MMM-YYYY")
    : "N/A";

  const requestDate = moment(
    selectedData?.request_date_created,
    "DD-MM-YYYY"
  ).format("DD-MMM-YYYY");

  const documentProps = {
    patientDataTitle: selectedData?.patient_fullname || "N/A",
    patientDataPatientID: selectedData?.patient_field_patient_id || "N/A",
    patientDataDateOfBirth: selectedData?.patient_date_of_birth
      ? `${moment().diff(
          moment(selectedData.patient_date_of_birth, "MM-DD-YYYY"),
          "years"
        )} years`
      : "N/A",
    patientDataGender: selectedData?.patient_gender || "N/A",
    referededBy: `${selectedData?.requester_first_name || ""} ${
      selectedData?.requester_last_name || ""
    }`,
    reportid: reportData?.data.attributes.drupal_internal__nid || "N/A",
    requestDataCreated: requestDate || "N/A",
    reportDataCreated: reportedDate || "N/A",
    investigationsDataTitle: selectedData?.request_investigation || "N/A",
    requestDataFieldClinicalDiagnosis:
      selectedData?.request_clinical_diag || "N/A",
    requestDataFieldComments: selectedData?.request_comments || "N/A",
    reportDataTitle: reportData?.data.attributes.title || "",
    reportDataFieldReportTechnique:
      reportData?.data.attributes.field_ct_scan_report_technique || "",
    reportDataFieldReportFindings:
      reportData?.data.attributes.field_ct_scan_report_findings || "",
    reportDataFieldReportImpression:
      reportData?.data.attributes.field_ct_scan_report_impression || "",
    reporterDataFieldDoctorRefererfullname: (() => {
      if (!reportData?.included?.[0]?.attributes) return "N/A";
      const firstName =
        reportData.included[0].attributes.field_first_name ?? "";
      const lastName = reportData.included[0].attributes.field_last_name ?? "";
      const fullName = `${firstName} ${lastName}`.trim();
      return fullName || "N/A";
    })(),
    reporterDataFieldSpecialty: selectedData?.report_field_specialty || "N/A",
    onClickAddReport: toggleModalAddReport,
    navigatingOnClickEdit: toggleModalEditReport,
    report_nid,
    permuser,
    activeRole: ls.get("currentuserrole") || "",
  };

  return (
    <>
      {report_nid && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: "48px",
            zIndex: 999,
            padding: "10px",
            display: "flex",
            gap: "10px",
          }}
        >
          <PDFDownloadLink
            document={<MyDocument {...documentProps} />}
            fileName={`CTScan_Report_${selectedData?.patient_fullname}_${selectedData?.patient_field_patient_id}.pdf`}
          >
            {({ loading }) => (
              <button
                style={{
                  background: "red",
                  fontSize: "15px",
                  padding: "8px 16px",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {loading ? "Preparing PDF..." : "Download report"}
                {!loading && <FontAwesomeIcon icon={faFilePdf} />}
              </button>
            )}
          </PDFDownloadLink>
        </div>
      )}
      <ReportTemplate {...documentProps} loadingreportData={isLoading} />
      {/* Add Report Modal */}
      {modalAddReport && (
        <div className="modal">
          <div className="overlay"></div>
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-header">
                <p>{`Add CT Scan report for ${
                  selectedData?.patient_fullname || "N/A"
                }`}</p>
                <button className="close-modal" onClick={toggleModalAddReport}>
                  <FontAwesomeIcon icon={faClose} />
                </button>
              </div>
              <AddCTScanReportRegister
                requestNID={selectedData?.request_nid}
                reportNID={selectedData?.report_nid}
                patientNID={selectedData?.patient_nid}
                patient_fullname={selectedData?.patient_fullname}
                requestInvestigationPrice={
                  selectedData?.request_field_investigation_price
                }
              />
            </div>
          </div>
        </div>
      )}{" "}
      s{/* Edit Report Modal */}
      {modalEditReport && reportData && (
        <div className="modal">
          <div className="overlay"></div>
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-header">
                <p>{`Edit CT Scan report for ${
                  selectedData?.patient_fullname || "N/A"
                }`}</p>
                <button className="close-modal" onClick={toggleModalEditReport}>
                  <FontAwesomeIcon icon={faClose} />
                </button>
              </div>
              <EditCTScanReportRegister
                request_request_nid={selectedData?.request_nid}
                report_report_main_title={
                  reportData?.data.attributes.title || ""
                }
                report_field_ct_scan_report_technique={
                  reportData?.data.attributes.field_ct_scan_report_technique ||
                  ""
                }
                report_field_ct_scan_report_findings={
                  reportData?.data.attributes.field_ct_scan_report_findings ||
                  ""
                }
                report_field_ct_scan_report_impression={
                  reportData?.data.attributes.field_ct_scan_report_impression ||
                  ""
                }
                report_field_ct_scan_report_status={
                  reportData?.data.attributes.field_ct_scan_report_status || ""
                }
                report_report_nid={report_nid}
                toggleModalEditReport={toggleModalEditReport}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewCTScanReportRegister;
